var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.RecipeList,{attrs:{"recipes":_setup.recipes,"loading":_setup.isLoadingRecipeList}})
}
var staticRenderFns = []

export { render, staticRenderFns }